/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\client\utilization\clientgeneratorconfigs\genclient.json
 */

"use strict";

import Contracts = require("Utilization/Scripts/Generated/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");
import VSS_WebApi_Constants = require("VSS/WebApi/Constants");

export class CommonMethods3To7_2 extends VSS_WebApi.VssHttpClient {

    public static serviceInstanceId = VSS_WebApi_Constants.ServiceInstanceTypes.TFS;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

export class CommonMethods4To7_2 extends CommonMethods3To7_2 {
    protected usageSummaryApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * Returns the usage summary for the given query criteria.
     *
     * @param {Contracts.UsageSummaryQueryCriteria} queryCriteria - The query criteria specifying the parameters of interest.
     * @return IPromise<Contracts.CommandUsage[]>
     */
    public getUsageSummary(
        queryCriteria: Contracts.UsageSummaryQueryCriteria
        ): IPromise<Contracts.CommandUsage[]> {

        const queryValues: any = {
            queryCriteria: queryCriteria
        };

        return this._beginRequest<Contracts.CommandUsage[]>({
            httpMethod: "GET",
            area: "Utilization",
            locationId: "d3709376-907a-49d8-b7a7-c4ea99ca3772",
            resource: "UsageSummary",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CommandUsage,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.usageSummaryApiVersion
        });
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient7_2 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "7.2-preview.2";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient7_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "7.1";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient7 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "7.0";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient6_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "6.1";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient6 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "6.0";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient5_2 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "5.2";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient5_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "5.1";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient5 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "5.0";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient4_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "4.1";
    }
}

/**
 * @exemptedapi
 */
export class UtilizationHttpClient4 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.usageSummaryApiVersion = "4.0";
    }
}

export class UtilizationHttpClient3_2 extends VSS_WebApi.VssHttpClient {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Obsolete] Returns the usage summary for the specified identity.
     *
     * @param {Contracts.UsageSummaryQueryCriteria} queryCriteria - The query criteria for this request
     * @return IPromise<Contracts.CommandUsage[]>
     */
    public getUsageSummary(
        queryCriteria: Contracts.UsageSummaryQueryCriteria
        ): IPromise<Contracts.CommandUsage[]> {

        const queryValues: any = {
            queryCriteria: queryCriteria
        };

        return this._beginRequest<Contracts.CommandUsage[]>({
            httpMethod: "GET",
            area: "Utilization",
            locationId: "d3709376-907a-49d8-b7a7-c4ea99ca3772",
            resource: "UsageSummary",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CommandUsage,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: "3.2"
        });
    }
}

export class UtilizationHttpClient3_1 extends VSS_WebApi.VssHttpClient {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Obsolete] Returns the usage summary for the specified identity.
     *
     * @param {Contracts.UsageSummaryQueryCriteria} queryCriteria - The query criteria for this request
     * @return IPromise<Contracts.CommandUsage[]>
     */
    public getUsageSummary(
        queryCriteria: Contracts.UsageSummaryQueryCriteria
        ): IPromise<Contracts.CommandUsage[]> {

        const queryValues: any = {
            queryCriteria: queryCriteria
        };

        return this._beginRequest<Contracts.CommandUsage[]>({
            httpMethod: "GET",
            area: "Utilization",
            locationId: "d3709376-907a-49d8-b7a7-c4ea99ca3772",
            resource: "UsageSummary",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CommandUsage,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: "3.1"
        });
    }
}

export class UtilizationHttpClient3 extends VSS_WebApi.VssHttpClient {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * [Obsolete] Returns the usage summary for the specified identity.
     *
     * @param {Contracts.UsageSummaryQueryCriteria} queryCriteria - The query criteria for this request
     * @return IPromise<Contracts.CommandUsage[]>
     */
    public getUsageSummary(
        queryCriteria: Contracts.UsageSummaryQueryCriteria
        ): IPromise<Contracts.CommandUsage[]> {

        const queryValues: any = {
            queryCriteria: queryCriteria
        };

        return this._beginRequest<Contracts.CommandUsage[]>({
            httpMethod: "GET",
            area: "Utilization",
            locationId: "d3709376-907a-49d8-b7a7-c4ea99ca3772",
            resource: "UsageSummary",
            routeTemplate: "_apis/{area}/{resource}",
            responseType: Contracts.TypeInfo.CommandUsage,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: "3.0"
        });
    }
}

export class UtilizationHttpClient extends UtilizationHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": UtilizationHttpClient7_2,
    "7.1": UtilizationHttpClient7_1,
    "7.0": UtilizationHttpClient7,
    "6.1": UtilizationHttpClient6_1,
    "6.0": UtilizationHttpClient6,
    "5.2": UtilizationHttpClient5_2,
    "5.1": UtilizationHttpClient5_1,
    "5.0": UtilizationHttpClient5,
    "4.1": UtilizationHttpClient4_1,
    "4.0": UtilizationHttpClient4,
    "3.2": UtilizationHttpClient3_2,
    "3.1": UtilizationHttpClient3_1,
    "3.0": UtilizationHttpClient3
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return UtilizationHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): UtilizationHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<UtilizationHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<UtilizationHttpClient7_1>(UtilizationHttpClient7_1, undefined, undefined, undefined, options);
    }
}
